import { render, staticRenderFns } from "./customer_address_edit.vue?vue&type=template&id=c7513e50&scoped=true"
import script from "./customer_address_edit.vue?vue&type=script&lang=js"
export * from "./customer_address_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7513e50",
  null
  
)

export default component.exports